import { LinkButton } from '@cian/ui-kit/button';
import { useDeviceType } from '@cian/ui-kit/responsive';
import cn from 'classnames';
import * as React from 'react';
import { useSelector } from 'react-redux';

import * as styles from './Buttons.css';
import { ButtonsForAbcExpContainer } from './ButtonsForAbcExpContainer';
import { EButtonGroupType, getButtonGroupType } from './utils'; // eslint-disable-next-line import/no-restricted-paths
import { CallButton } from '../../../ListingDesktop/components/CallButton'; // eslint-disable-next-line import/no-restricted-paths
import { PhoneNumbers } from '../../../ListingDesktop/components/PhoneNumbers';
import { useIsDailyrentOnlineBookingEnabled } from '../../../common/hooks/useIsDailyrentOnlineBookingEnabled';
import { IDailyRentOfferForMobileSite } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { selectABCActionButtonExpGroup } from '../../../common/selectors/experiments/selectABCActionButtonExpGroup';
import { ChatButton } from '../ChatButton';

interface IButtonProps {
  className?: string;
  offer: IDailyRentOfferForMobileSite;
  offerLink: string;
  onMoreClick(): void;
  onBookClick(): void;
  onCallClick(): void;
  onChatClick(): void;
}

export const ButtonsContainer = (props: IButtonProps) => {
  const { className, offer, onCallClick, onChatClick } = props;

  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const isDailyrentOnlineBookingEnabled = useIsDailyrentOnlineBookingEnabled();
  const actionButtonExpGroup = useSelector(selectABCActionButtonExpGroup);
  const { phones } = offer;
  const phoneNumber = phones[0];

  // для десктопа
  const [showPhoneNumbers, setShowPhoneNumbers] = React.useState(false);
  const handleCallClick = () => {
    setShowPhoneNumbers(true);
    onCallClick();
  };

  const buttonGroup = getButtonGroupType({
    offer,
    deviceType,
    isDailyrentOnlineBookingEnabled,
  });

  if (isMobile && ['B', 'C'].includes(actionButtonExpGroup || '')) {
    return <ButtonsForAbcExpContainer {...props} />;
  }

  switch (buttonGroup) {
    case EButtonGroupType.CIAN_OFFER_MOBILE: {
      return (
        <div className={cn(styles['root'], className)}>
          <div className={styles['button-container']}>
            <LinkButton
              href={`tel:${phoneNumber}`}
              onClick={onCallClick}
              data-actionType={offer.actionType}
              role="button"
              fullWidth
            >
              Позвонить
            </LinkButton>
          </div>
          <ChatButton offer={offer} onClick={onChatClick} />
        </div>
      );
    }
    case EButtonGroupType.CIAN_OFFER_DESKTOP: {
      return (
        <div className={cn(styles['root'], styles['root_desktop'], className)}>
          {showPhoneNumbers ? (
            <PhoneNumbers phones={phones} />
          ) : (
            <div className={styles['button-container']}>
              <CallButton onClick={handleCallClick} phones={phones} actionType={offer.actionType} />
            </div>
          )}
        </div>
      );
    }
    case EButtonGroupType.ONLY_CHAT: {
      return (
        <div className={cn(styles['root'], className)}>
          <div className={styles['button-container']}>
            <ChatButton offer={offer} onClick={onChatClick} theme="fill_primary" />
          </div>
        </div>
      );
    }
    case EButtonGroupType.CIAN_OFFER_MOBILE_ONLINE_BOOKING:
    case EButtonGroupType.CIAN_OFFER_DESKTOP_ONLINE_BOOKING:
    case EButtonGroupType.PARTNER_OFFER_MOBILE:
    case EButtonGroupType.PARTNER_OFFER_DESKTOP:
    default: {
      return null;
    }
  }
};
